export enum MOTIVES_TYPES {
	LINE = "line",
	BAR = "bar",
	CAPACITY = "capacity",
	MAX_OCCUPANCY = "occupancyMaximum",
	MIN_OCCUPANCY = "occupancyMinimum",
}

export enum TYPES {
	LINE = "line",
	BAR = "bar",
}

export enum SCALES {
	Y = "y",
	Y_SECONDARY = "ySecondary",
	Y_MIN = "yMin",
	Y_MAX = "yMax",
	Y_CAPACITY = "yCap",
	X = "x",
}

export enum LEGEND_POSITIONS {
	TOP = "top",
	RIGHT = "right",
	BOTTOM = "bottom",
	LEFT = "left",
}

export enum LABEL_VALUES {
	AMOUNT = "amount",
	PERCENTAGE = "percentage",
	PERCENTAGE_OF_TOTAL = "percentageOfTotal",
	CATEGORY = "category",
}

export enum GRAPH_DEFAULTS {
	TOOLTIP_BACKGROUND_COLOR = "rgb(var(--color-surface))",
	TOOLTIP_BACKGROUND_COLOR_DARK = "rgba(57,70,92,1)",

	LINE_COLOR = "rgba(32,41,57,0.12)",
	LINE_COLOR_THICK = "rgba(32,41,57,0.26)",
	LINE_COLOR_DARK = "rgba(226,227,229,0.15)",

	TEXT_COLOR = "rgba(32,41,57,1)",
	TEXT_COLOR_DARK = "rgba(226,227,229,1)",
}

export enum GRAPH_MIRROR_DIRECTIONS {
	UP = "up",
	DOWN = "down",
}

export enum GRAPH_VERTICAL_TYPES {
	NORMAL = "normal",
	MIRRORED = "mirrored",
}

export enum GRAPH_TYPES {
	BAR = "bar",
	AREA = "area",
	LINE = "line",
}
